import { render } from "./TheSearchPanel.vue?vue&type=template&id=2a8e4a07"
import script from "./TheSearchPanel.vue?vue&type=script&lang=js"
export * from "./TheSearchPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__